<template>
    <div class="case">
        <router-link :to="`/case/${slug}`">
            <img :src="img" alt="">
        </router-link>
        <div class="content">
            <p class="small_title">
                {{title}}
            </p>
            <!-- <p class="small_title">
                {{subtitle}}
            </p> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "CaseBlock",
    props: {
        title: String,
        subtitle: String,
        slug: {
            type: String,
            default: '/'
        },
        img: String,
    }

}
</script>

<style lang="scss" scoped>
.case{
    width: 50%;
    margin: 0;
    margin-top: 13px;
    margin-bottom: 44px;
    img{
        width: 100%;
        object-fit: cover;
        height: 400px;
    }
    .content{
        text-align: center;
        h3{
            margin: 0;
            margin-top: 22px;
        }
        p{
            padding-top: 22px;
            color: #000;
            text-transform: uppercase;
            margin: 0;
        }
    }
}
@media (max-width: $mobile) { 
    .case{
        width: 100%;
        margin: 1rem 0 61px;
        img{
            height: 300px;
        }
        .content{
            margin: 0;
            h3{
                margin: 0 2rem;
                margin-top: 1rem;
            }
            p{
                margin: 0 2rem;
            }
        }
    }
}
</style>